import { ServerValue } from "@firebase/database";
import { Community } from "./../services/community/community";
import { PapaParseService } from "ngx-papaparse";
export class BackendService {
  private static community: Community;

  constructor() { }

  static generateUserId(email: string): string {
    const invalidCharacters = {
      ".": true,
      "#": true,
      $: true,
      "@": true,
      "[": true,
      "]": true
    };

    if (!email) {
      return "";
    }

    const key = email
      .split("")
      .map(v => {
        if (invalidCharacters[v]) {
          return "~";
        } else {
          return v;
        }
      })
      .join("");

    return key;
  }

  static getCurrentTimeStamp(): any {
    return ServerValue.TIMESTAMP;
  }

  static setActiveCommunity(community: Community): void {
    this.community = community;
  }

  static getActiveCommunity(): Community {
    return this.community;
  }

  static sortRecords(records, sortBy): any {
    return records.sort((a, b) => {
      const previous = typeof a[sortBy] === "string" ? a[sortBy].toLowerCase() : a[sortBy];
      const current = typeof b[sortBy] === "string" ? b[sortBy].toLowerCase() : b[sortBy];

      let comparison = 0;
      if (previous > current) {
        comparison = 1;
      } else if (previous < current) {
        comparison = -1;
      }

      return comparison;
    });
  }

  static downloadEntities(entity, fileName): void {
    const csvParseService = new PapaParseService();
    const csv = csvParseService.unparse(entity);
    fileName = `${fileName}.csv`;
    const blob = new Blob([csv]);
    if (window.navigator.msSaveOrOpenBlob) {
      // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
      window.navigator.msSaveBlob(blob, fileName);
    } else {
      const link = window.document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/backend.service.ts